import { CalendarDays, Users, Calculator as CalcIcon, FileText, Receipt, Wrench, Camera, LayoutDashboard, Truck, ListOrdered, TrendingUp, BarChart3, ShieldAlert, ListChecks, FilePlus2, Building2, Archive, HardDrive, Boxes, ShoppingCart, Contact, PackagePlus, Repeat, HardHat, LayoutDashboard as FlDash, ClipboardList, Wallet, FileSpreadsheet, IdCard, CalendarCheck, Clock3, FolderLock, FileBarChart2, FileStack } from "lucide-react";

export const MODULES = {
  sales: { key: "sales", label: "Sales & Invoicing", zh: "销售与发票", home: "/calendar", tone: "amber",
    nav: [
      { to: "/calendar", en: "Calendar", zh: "日历", icon: CalendarDays, testid: "nav-calendar" },
      { to: "/app", en: "Customers", zh: "客户", icon: Users, testid: "nav-customers" },
      { to: "/quote", en: "Quote", zh: "报价", icon: CalcIcon, testid: "nav-quote" },
      { to: "/quotes", en: "Activity", zh: "活动记录", icon: FileText, testid: "nav-quotes" },
      { to: "/invoices", en: "Invoices", zh: "发票", icon: Receipt, testid: "nav-invoices" },
      { to: "/workshop", en: "Workshop", zh: "车间", icon: Wrench, testid: "nav-workshop" },
    ] },
  purchases: { key: "purchases", label: "Bills & Purchases", zh: "账单与采购", home: "/purchases", tone: "emerald",
    nav: [
      { to: "/purchases", en: "Overview", zh: "概览", icon: LayoutDashboard, testid: "nav-purchases" },
      { to: "/purchases/capture", en: "Capture", zh: "拍照", icon: Camera, testid: "nav-capture" },
      { to: "/purchases/bills", en: "Bills", zh: "账单", icon: ListOrdered, testid: "nav-bills" },
      { to: "/purchases/suppliers", en: "Suppliers", zh: "供应商", icon: Truck, testid: "nav-suppliers" },
      { to: "/purchases/statements", en: "Statements", zh: "对账单", icon: FileStack, testid: "nav-statements" },
      { to: "/purchases/recurring", en: "Recurring", zh: "固定开支", icon: Repeat, testid: "nav-recurring" },
      { to: "/purchases/export", en: "Export", zh: "导出", icon: Archive, testid: "nav-export" },
      { to: "/purchases/storage", en: "Storage", zh: "存储", icon: HardDrive, testid: "nav-storage" },
    ] },
  pnl: { key: "pnl", label: "Profit & Loss", zh: "损益", home: "/pnl", tone: "sky",
    nav: [
      { to: "/pnl", en: "P&L", zh: "损益表", icon: TrendingUp, testid: "nav-pnl" },
      { to: "/reports", en: "Reports", zh: "报告", icon: BarChart3, testid: "nav-reports" },
    ] },
  claims: { key: "claims", label: "Insurance Claims", zh: "保险索赔", home: "/claims", tone: "rose",
    nav: [
      { to: "/claims", en: "Overview", zh: "概览", icon: ShieldAlert, testid: "nav-claims" },
      { to: "/claims/list", en: "All Claims", zh: "索赔列表", icon: ListChecks, testid: "nav-claims-list" },
      { to: "/claims/new", en: "New Claim", zh: "新索赔", icon: FilePlus2, testid: "nav-claims-new" },
      { to: "/claims/insurers", en: "Insurers", zh: "保险公司", icon: Building2, testid: "nav-insurers" },
    ] },
  inventory: { key: "inventory", label: "General Inventory", zh: "零件目录", home: "/inventory", tone: "violet",
    nav: [
      { to: "/inventory", en: "Catalogue", zh: "目录", icon: Boxes, testid: "nav-inventory" },
      { to: "/inventory/order-list", en: "Order List", zh: "采购清单", icon: ShoppingCart, testid: "nav-order-list" },
      { to: "/inventory/suppliers", en: "Suppliers", zh: "供应商", icon: Contact, testid: "nav-inv-suppliers" },
      { to: "/inventory/new", en: "Add Item", zh: "新增", icon: PackagePlus, testid: "nav-inv-new" },
    ] },
  freelance: { key: "freelance", label: "Freelance Workers", zh: "外包师傅", home: "/freelance", tone: "teal",
    nav: [
      { to: "/freelance", en: "Dashboard", zh: "概览", icon: FlDash, testid: "nav-fl-dashboard" },
      { to: "/freelance/workers", en: "Workers", zh: "师傅", icon: HardHat, testid: "nav-fl-workers" },
      { to: "/freelance/records", en: "Work Records", zh: "工作记录", icon: ClipboardList, testid: "nav-fl-records" },
      { to: "/freelance/payments", en: "Payments", zh: "付款", icon: Wallet, testid: "nav-fl-payments" },
      { to: "/freelance/statements", en: "Monthly Statements", zh: "月结单", icon: FileSpreadsheet, testid: "nav-fl-statements" },
      { to: "/freelance/client-invoices", en: "Client Invoices", zh: "客户发票", icon: Receipt, testid: "nav-fl-client-invoices" },
    ] },
  hr: { key: "hr", label: "HR", zh: "人事", home: "/hr", tone: "orange", requires: "hr",  // standalone employee records — no data shared with other modules
    nav: [
      { to: "/hr", en: "Dashboard", zh: "概览", icon: LayoutDashboard, testid: "nav-hr-dashboard" },
      { to: "/hr/employees", en: "Employees", zh: "员工", icon: IdCard, testid: "nav-hr-employees" },
      { to: "/hr/leave", en: "Leave", zh: "请假", icon: CalendarCheck, testid: "nav-hr-leave" },
      { to: "/hr/attendance", en: "Attendance", zh: "考勤", icon: Clock3, testid: "nav-hr-attendance" },
      { to: "/hr/documents", en: "Documents", zh: "文件", icon: FolderLock, testid: "nav-hr-documents" },
      { to: "/hr/reports", en: "Reports", zh: "报告", icon: FileBarChart2, testid: "nav-hr-reports" },
    ] },
};

export const GLOBAL = { key: "global", label: "Dashboard", zh: "总览", home: "/dashboard", tone: "amber", nav: [] };  // no module sub-nav on the workspace picker / reports
export const moduleFor = (pathname) => {
  if (pathname === "/dashboard" || pathname.startsWith("/reports")) return GLOBAL;
  if (pathname.startsWith("/purchases")) return MODULES.purchases;
  if (pathname.startsWith("/pnl")) return MODULES.pnl;
  if (pathname.startsWith("/claims")) return MODULES.claims;
  if (pathname.startsWith("/inventory")) return MODULES.inventory;
  if (pathname.startsWith("/freelance")) return MODULES.freelance;
  if (pathname === "/hr" || pathname.startsWith("/hr/")) return MODULES.hr;
  return MODULES.sales;
};

export const isNavActive = (pathname, to) => pathname === to || (to === "/app" && pathname.startsWith("/customers/")) || (to === "/purchases/bills" && pathname.startsWith("/purchases/bills/"))
  || (to === "/hr/employees" && pathname.startsWith("/hr/employees/"))
  || (to === "/purchases/statements" && pathname.startsWith("/purchases/statements/"))
  || (to === "/freelance/client-invoices" && pathname.startsWith("/freelance/client-invoices/"))
  || (to === "/claims/list" && /^\/claims\/[^/]+$/.test(pathname) && !["/claims/new", "/claims/insurers", "/claims/list"].includes(pathname))
  || (to === "/inventory" && /^\/inventory\/items\//.test(pathname)) || (to === "/inventory/suppliers" && pathname.startsWith("/inventory/suppliers/"));
